import { Grid, View } from '@gogame/components';

export const SuspenseFallback = () => (
  <Grid
    container
    direction={'column'}
    align={'center'}
    justifyContent={'center'}
    style={{ height: '100%' }}
  >
    <Grid item style={{ height: '100%' }}>
      <View loading={true} transparent={false} />
    </Grid>
  </Grid>
);
